module.exports = __webpack_public_path__ + "static/media/hero-image.1814cbd2.jpg";